import React, { useState, useEffect } from 'react';
import SearchBox from '../../components/SearchComponent';
import TableComponent from '../../components/TableComponent';
import ButtonElement from '../../../Common/ButtonElement';
import { TiPencil, TiTrash } from 'react-icons/ti';
import AddBiling from './AddBilingCompany';
import { appApis, headerColumn } from '../../../constants';
import { useApiRequest } from '../../../hooks/useApiRequest';
import { DELETE_POP_UP } from '../../../utils';
import { useMemo } from 'react';

const headers = headerColumn.billingCompanies;

const BillingCompany = () => {
    const [search, setSearch] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [editCompany, setEditCompany] = useState(null);
    const [billingCompanies, setBillingCompanies] = useState([]);
    const { request, loading } = useApiRequest();

    // Fetch billing companies data using useApiRequest hook
    const fetchBillingCompanies = async () => {
        await request({
            method: 'GET',
            url: appApis.billingCompanies,
            showToast: false,
            onSuccess: (response) => {
                setBillingCompanies(response?.data?.billingCompanies || []);
            }
        });
    };

    // Filter companies by search using API data
    // useMemo to avoid recalculating on every render
    const filteredCompanies = useMemo(() => {
        return billingCompanies.filter(company =>
            company.companyName?.toLowerCase().includes(search.toLowerCase()) ||
            company.gstNumber?.toLowerCase().includes(search.toLowerCase()) ||
            company.email?.toLowerCase().includes(search.toLowerCase())
        );
    }, [billingCompanies, search]);

    const handleEdit = (company) => {
        setEditCompany(company);
        setShowModal(true);
    };

    const handleDelete = (company) => {
        DELETE_POP_UP(() => {
            request({
                method: 'DELETE',
                url: `${appApis.deleteBillingComapny}/${company.billingCompanyId}`,
                onSuccess: fetchBillingCompanies,
            });
        });
    };

    // Callback function to refresh data after successful edit/add
    const handleModalClose = (isRequest) => {
        // if (isRequest) fetchBillingCompanies();
        setShowModal(false);
        setEditCompany(null);
    };

    // Fetch data on component mount
    useEffect(() => {
        fetchBillingCompanies();
    }, []);

    return (
        <div className="user-container">
            <SearchBox
                placeholder='Search companies or GSTIN...'
                className='mb-3'
                value={search}
                onChange={(e) => setSearch(e.target.value)}
            />

            <TableComponent
                title="Billing Companies List"
                col={7}
                headers={headers}
                data={filteredCompanies}
                tableLoading={loading}
                render={(tdData, index) =>
                    <tr key={index}>
                        <td>{(index ?? 0) + 1}</td>
                        <td>
                            <div>
                                <strong>{tdData?.companyName ?? "-"}</strong>
                                <div className="text-muted small">{tdData?.address ?? "-"}</div>
                            </div>
                        </td>
                        <td>
                            <span className={`badge ${tdData?.gstType === 'GST' ? 'bg-success' : 'bg-secondary'}`}>
                                {tdData?.gstType ?? "-"}
                            </span>
                        </td>
                        <td>
                            <code className="bg-light px-2 py-1 rounded">{tdData?.gstNumber ?? "-"}</code>
                        </td>
                        <td>
                            <code className="bg-light px-2 py-1 rounded">{tdData?.hsnCode ?? tdData?.hsn_code ?? "-"}</code>
                        </td>
                        <td>
                            <code className="bg-light px-2 py-1 rounded">{tdData?.sacCode ?? tdData?.sac_code ?? "-"}</code>
                        </td>
                        <td>
                            <div>
                                <div>{tdData?.mobileNo ?? "-"}</div>
                                <div className="text-muted small">{tdData?.email ?? "-"}</div>
                            </div>
                        </td>
                        <td>
                            <div className="action d-flex justify-content-center align-items-center px-3">
                                <ButtonElement text={<TiPencil size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => handleEdit(tdData)} variant="btn-outline-edit" />
                                <ButtonElement text={<TiTrash size={20} />} cssClass="more-radius mx-1 px-4" onClick={() => handleDelete(tdData)} variant="btn-outline-danger" />
                            </div>
                        </td>
                    </tr>}
                FilterComponent={
                    <div className="d-flex justify-content-end">
                        <ButtonElement text="Add Billing Company" cssClass="small-radius ms-2 mb-1" onClick={() => {
                            setEditCompany(null);
                            setShowModal(true);
                        }} variant="btn-black" />
                    </div>
                }
            />
            {showModal && (
                <AddBiling
                    show={showModal}
                    hideModal={handleModalClose}
                    onSuccess={() => handleModalClose(true)}
                    companyData={editCompany}
                />
            )}
        </div>
    );
};

export default BillingCompany;